"use client";

import React, { useCallback, useEffect, useState } from "react";
import { EmblaCarouselType } from "embla-carousel";
// import { EmblaCarouselType } from "embla-carousel/components/EmblaCarousel";
import { GroupHeader } from "../../../ui/Headers";
import { TestimonialsType } from "../../../constants/testimonialsData";
import { useTestimonialsCarousel } from "src/app/lib/useTestimonials";
import Image from "next/image";
type UseDotButtonType = {
  selectedIndex: number;
  scrollSnaps: number[];
  onDotButtonClick: (index: number) => void;
};
export const useDotButton = (
  emblaApi: EmblaCarouselType | undefined
): UseDotButtonType => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
  const onDotButtonClick = useCallback(
    (index: number) => {
      if (!emblaApi) return;
      emblaApi.scrollTo(index);
    },
    [emblaApi]
  );

  const onInit = useCallback((emblaApi: EmblaCarouselType) => {
    setScrollSnaps(emblaApi.scrollSnapList());
  }, []);

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on("reInit", onInit).on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onInit, onSelect]);

  return {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick,
  };
};

const Testimonials = () => {
  const { emblaRef, canScrollPrev, canScrollNext, emblaApi, testimonials } =
    useTestimonialsCarousel();

  if (testimonials?.length === 0) return null;
  return (
    <section className="py-14">
      <div className="wrapper">
        <GroupHeader
          max={1024}
          subheader="Hear what our clients say about their exceptional experiences and success stories with us."
          header="Our Clients Success Stories"
        />
      </div>
      <div className="wrapper relative overflow-hidden">
        <button
          className={`absolute   top-1/2 transform -translate-y-1/2 z-10 ${
            canScrollPrev ? "visible" : "invisible"
          }`}
          onClick={() => emblaApi && emblaApi.scrollPrev()}
        >
          <svg
            width="23"
            height="40"
            viewBox="0 0 23 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.1211 39.092C22.6836 38.5294 22.9995 37.7665 22.9995 36.971C22.9995 36.1755 22.6836 35.4126 22.1211 34.85L7.27114 20L22.1211 5.14998C22.6676 4.58417 22.97 3.82636 22.9632 3.03977C22.9563 2.25318 22.6408 1.50074 22.0846 0.944519C21.5284 0.388294 20.7759 0.0727921 19.9893 0.0659561C19.2028 0.0591202 18.445 0.361504 17.8791 0.907978L0.908144 17.879C0.345731 18.4416 0.0297852 19.2045 0.0297852 20C0.0297852 20.7955 0.345731 21.5584 0.908144 22.121L17.8791 39.092C18.4417 39.6544 19.2047 39.9703 20.0001 39.9703C20.7956 39.9703 21.5586 39.6544 22.1211 39.092Z"
              fill="var(--primary-color)"
            />
          </svg>
        </button>
        <button
          className={`absolute rotate-180 right-0  top-1/2 transform -translate-y-1/2 z-10 ${
            canScrollNext ? "visible" : "invisible"
          }`}
          onClick={() => emblaApi && emblaApi.scrollNext()}
        >
          <svg
            width="23"
            height="40"
            viewBox="0 0 23 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.1211 39.092C22.6836 38.5294 22.9995 37.7665 22.9995 36.971C22.9995 36.1755 22.6836 35.4126 22.1211 34.85L7.27114 20L22.1211 5.14998C22.6676 4.58417 22.97 3.82636 22.9632 3.03977C22.9563 2.25318 22.6408 1.50074 22.0846 0.944519C21.5284 0.388294 20.7759 0.0727921 19.9893 0.0659561C19.2028 0.0591202 18.445 0.361504 17.8791 0.907978L0.908144 17.879C0.345731 18.4416 0.0297852 19.2045 0.0297852 20C0.0297852 20.7955 0.345731 21.5584 0.908144 22.121L17.8791 39.092C18.4417 39.6544 19.2047 39.9703 20.0001 39.9703C20.7956 39.9703 21.5586 39.6544 22.1211 39.092Z"
              fill="var(--primary-color)"
            />
          </svg>
        </button>
        <div ref={emblaRef} className="items gap-4 ">
          <div className="parent flex">
            {testimonials?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="basis-1/2 xl:basis-full max-w-[100vw] tets flex justify-end md:justify-start select-none  shrink-0"
                >
                  <Card key={index} {...item} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Testimonials;

const Card: React.FC<TestimonialsType> = ({
  name,
  comment,
  image,
  reviewType,
}) => {
  return (
    <div className="relative  card-scale xs:scale-[0.9] xl:mx-auto min-w-[300px]  w-[clamp(580px,40vw,600px)] ">
      <svg
        width="100%"
        height="auto"
        className=""
        viewBox="0 0 566 347"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1580_89858)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M62.3355 112.239C93.3131 112.239 118.425 87.1263 118.425 56.1488C118.425 52.0558 117.987 48.0652 117.155 44.2214C116.505 41.221 118.673 38.1995 121.742 38.1995H509.932C512.411 38.1995 514.42 40.2084 514.42 42.6866V309.674C514.42 312.152 512.411 314.161 509.932 314.161H48.8741C46.3959 314.161 44.387 312.152 44.387 309.674V115.556C44.387 112.486 47.4085 110.318 50.4088 110.968C54.2524 111.8 58.2428 112.239 62.3355 112.239Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1580_89858"
            x="0.462227"
            y="-5.72527"
            width="565.521"
            height="371.45"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="3.81954" dy="3.81954" />
            <feGaussianBlur stdDeviation="23.8721" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1580_89858"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1580_89858"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
      <div className="image-round z-[5] overflow-hidden rounded-full absolute top-[2%] left-[2%] aspect-square w-[17%]">
        <Image
          layout="fill"
          className="object-cover bg-[rgba(var(--primary-color-rgb),0.7)] w-full aspect-square"
          src={image as string}
          alt="user image"
        />
      </div>
      <div className="line absolute bg-themeColor top-[38%] left-[8%]   h-[3px] w-[calc(100%-17%)]"></div>
      <div className="card-text min-w-[300px]  w-[calc(100%-5rem)]    top-[13%] absolute">
        <div className="pl-[34%]">
          <h4 className="font-semibold line-clamp-1 text-secondary-main">
            {name}
          </h4>
          <ReviewBadge reviewType={reviewType} />
        </div>
        <h6 className="pl-[15%] xs:pt-[2rem] pt-[3.4rem] relative text-secondary-main">
          {comment.slice(0, 150)}...
        </h6>
      </div>
    </div>
  );
};

export const ReviewBadge: React.FC<{
  reviewType: "positive" | "negative" | "neutral";
  flag?: boolean;
  className?: string;
  headerAs?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6"; // Union type for header tags
}> = ({ reviewType, flag = false, className, headerAs = "h4" }) => {
  const getColor = () => {
    if (reviewType === "positive") return "green";
    if (reviewType === "negative") return "red";
    return "#F89900FC"; // Neutral case
  };

  const getLabel = () => {
    if (flag) return reviewType.charAt(0).toUpperCase() + reviewType.slice(1); // "Positive", "Negative", "Neutral"
    if (reviewType === "positive") return "Positive Review";
    if (reviewType === "negative") return "Negative Review";
    return "Neutral Review";
  };

  const HeaderTag = headerAs; // Dynamically set the header tag

  return (
    <HeaderTag style={{ color: getColor() }} className={`${className} h6`}>
      {getLabel()}
    </HeaderTag>
  );
};
